import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE, IF_ANY } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page}  >Login Issues</PageHeader>
        <SwitchRow {...page}  keyName= {LocationVarKey.VoiceLoginIssuesHasLLM} label="✨ Enhance with AI"/>
        <TextRow {...page}  hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceLoginIssuesHasLLM,"1")}>
        <div className="rainbowPower">
        Your AI assistant will enhance the answer below using contextual data from the customer’s profile, conversation history, and your knowledge graph.
        </div>
        </TextRow>
        <TextAreaRow {...page}  
            marginTop
            label=" Voice Message"
            keyName= {LocationVarKey.VoiceLoginIssuesMessage}
        />
        <SwitchRow {...page}  keyName= {LocationVarKey.VoiceSendLoginIssuesText} label="Send SMS" />
        <TextAreaRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendLoginIssuesText,"1")}
            marginTop
            label=" SMS Message"
            keyName= {LocationVarKey.VoiceLoginIssuesTextMessage}
        />
        <SwitchRow {...page}  keyName= {LocationVarKey.VoiceForwardLoginIssues} label="Escalate" />
        <DropdownRow
            {...page}
            hideIf={IS_EQUAL(LocationVarKey.VoiceForwardLoginIssues, "0")}
            label="Send escalations to"
            marginTop
            keyName={LocationVarKey.VoiceLoginIssuesEscalateTo}
            options={[
              { label: "swivl Conversations", value: "swivl" },
              { label: "External Phone Number", value: "phone" },
            ]}
          />
      <InputRow
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceForwardLoginIssues,"1"),IS_EQUAL(LocationVarKey.VoiceLoginIssuesEscalateTo,"swivl")])}
        keyName={LocationVarKey.VoiceLoginIssuesPhoneNumber}
        label="External Phone Number"
      />         
    </>
}